<template>
  <div>
    <div class="taocan" v-for="item in msg" :key="item.id">
      <div style="background-color: white; padding: 0 10px">
        <div style="display: flex; align-items: center">
          <img
            v-if="item.falseOp == '中国电信'"
            style="width: 120px; height: 35px"
            src="../assets/YM-DX.png"
          />
          <img
            v-if="item.falseOp == '中国联通'"
            style="width: 120px; height: 35px"
            src="../assets/YM-LT.png"
          />
          <img
            v-if="item.falseOp == '三网通'"
            style="width: 120px; height: 35px"
            src="../assets/YM-SWT.png"
          />
          <img
            v-if="item.falseOp == '中国移动'"
            style="width: 120px; height: 35px"
            src="../assets/YM-YD.png"
          />
          <img
            v-if="item.falseOp == '中国广电'"
            style="width: 120px; height: 35px"
            src="../assets/g.png"
          />
          <p
            style="
              width: 90%;
              border: 0px;
              text-align: right;
              margin-left: 10px;
              font-size: 18px;
            "
          >
            {{ item.card2 }}
          </p>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            text-align: left;
            font-size: 14px;
          "
        >
          <span>备注信息: {{ item.remark }}</span>
          <van-tag type="primary" size="medium">
            <!-- <van-icon color="white" size="15" name="coupon-o" /> -->
            <div v-if="item.state == -1" class="names">未知</div>
            <div v-if="item.state == 0" class="names">正常</div>
            <div v-if="item.state == 1" class="names">单项停机</div>
            <div v-if="item.state == 2" class="names">停机</div>
            <div v-if="item.state == 3" class="names">预销号</div>
            <div v-if="item.state == 4" class="names">销号/拆机</div>
            <div v-if="item.state == 5" class="names">过户</div>
            <div v-if="item.state == 6" class="names">休眠</div>
            <div v-if="item.state == 7" class="names">待激活</div>
            <div v-if="item.state == 8" class="names">已停用</div>
            <div v-if="item.state == 9" class="names">库存</div>
            <div v-if="item.state == 10" class="names">已失效</div>
            <div v-if="item.state == 11" class="names">违章停机</div>
            <div v-if="item.state == 12" class="names">挂失</div>
            <div v-if="item.state == 13" class="names">用户报停</div>
            <div v-if="item.state == 14" class="names">不存在</div>
            <div v-if="item.state == 15" class="names">低速</div>
            <div v-if="item.state == 16" class="names">可测试</div>
          </van-tag>
        </div>
      </div>
      <div>
        <van-progress
          style="margin: 10px 10px"
          :percentage="item.cc"
          stroke-width="9"
        />
      </div>
      <div class="info">
        <div class="detail-list">
          <div class="names">
            {{ Math.floor((item.sumFlow / 1024) * 100) / 100 }}G
          </div>
          <div class="names">总流量</div>
        </div>
        <div class="detail-list">
          <div class="names">
            {{ Math.floor((item.consumeFlow / 1024) * 100) / 100 }}G
          </div>
          <div class="names">已使用</div>
        </div>
        <div class="detail-lists">
          <div class="names">
            {{ Math.floor((item.surplusFlow / 1024) * 100) / 100 }}G
          </div>
          <div class="names">未使用</div>
        </div>
        <div class="detail-lists">
          <div class="names">{{ item.balance }}</div>
          <div class="names">卡板余额</div>
        </div>
      </div>
      <div class="infos">
        <van-button
          @click="routers(item.card2)"
          icon="newspaper-o"
          style="margin-bottom: 10px; border-radius: 5px"
          size="small"
          type="info"
        >
          查看详情
        </van-button>

        <van-button
          @click="router(item.card2)"
          icon="replay"
          style="margin-bottom: 10px; border-radius: 5px"
          size="small"
          type="primary"
        >
          刷新流量
        </van-button>
        <van-button
          icon="delete-o"
          style="
            margin-bottom: 10px;
            border-radius: 5px;
            background-color: red;
            border: 0px solid red;
          "
          size="small"
          type="info"
          @click="deletess(item.id)"
        >
          删除卡号
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { refreshPhone } from "../api/cardOperation";
  export default {
    name: "Card",
    props: ["msg"],
    data() {
      return {
        fom: [],
        cc: "",
      };
    },
    created: {},
    methods: {
      router() {
        refreshPhone().then((res) => {
          if (res.status) {
            this.$emit("fatherMethod");
            this.$notify({
              type: "success",
              message: res.msg,
            });
          } else {
            this.$notify({
              type: "warning",
              message: res.msg,
            });
          }
        });
      },
      routers(val) {
        console.log(val);
        this.axios.get(`/app/cardSave/getByCard?card=${val}`).then((res) => {
          if (res.data.status) {
            console.log(res);
            localStorage.removeItem("meCardNum");
            localStorage.setItem("meCardNum", val);
            localStorage.removeItem("card");
            localStorage.setItem("card", localStorage.getItem("meCardNum"));

            localStorage.removeItem("222");
            this.$router.push("/home");
          } else {
            console.log(res);
            this.$notify({ type: "warning", message: `${res.data.msg}` });
          }
        });
      },
      deletess(val) {
        this.axios.get(`/app/cardSave/delCardSave?id=${val}`).then((res) => {
          if (res.data.status) {
            console.log(res);
            this.msg.forEach((item) => {
              if (item.id == val) {
                this.msg.splice(item, 1);
              }
            });
            this.$notify({ type: "success", message: "删除成功" });
          } else {
            this.$notify({ type: "success", message: res.data.msg });
          }
        });
      },
      copy() {
        var e = document.getElementById("target");
        e.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$toast("复制成功");
      },
    },
  };
</script>

<style scoped lang="scss">
  .taocan {
    position: relative;
    border-radius: 10px;
    margin: 10px 0;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
  }
  .delete {
    position: absolute;
    top: 3px;
    right: 10px;
  }
  .ax {
    // margin-bottom: 10px;
    font-size: 13px;
    color: rgba(128, 128, 128, 1);
    background-color: white;
  }
  .axs {
    font-size: 13px;

    background-color: white;
  }
  .info {
    display: flex;
    justify-content: space-around;
    margin: 10px;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
    .detail-list {
      margin-left: 3%;
      .names {
        margin-top: 7px;
        margin-bottom: 7px;
        font-size: 14px;
      }
    }
    .detail-lists {
      margin-left: 3%;
      .names {
        margin-top: 7px;
        margin-bottom: 7px;
        font-size: 14px;
      }
    }
  }

  .infos {
    display: flex;
    justify-content: space-around;
  }
</style>
